import { html } from '@shared/utils/rendering/html';
import withAuthGuard from '@core/utils/routing/with-auth-guard';
import withRoleGuard from '@core/utils/routing/with-role-guard';
import UploadEvidenceForm from '../attestation-forms/upload-evidence-form';
import ReviewEvidenceForm from '../attestation-forms/review-evidence-form';
import EditEvidenceForm from '../attestation-forms/edit-evidence-form';
import ViewEvidenceForm from '../attestation-forms/view-evidence-form';

const MissingPermissionsCard = ({ message, isAuthenticated }) => {
    const errorMessage =
        message ||
        (isAuthenticated
            ? 'You do not have the required roles to access this resource at this time.'
            : 'Please sign in to access this resource');

    return html`
        <div class="card-header"><h4>Missing Permissions</h4></div>
        <div class="card-body">
            <div>${errorMessage}</div>
        </div>
    `;
};

export const createGuardedComponents = (rowData) => {
    return {
        Capture: withAuthGuard(
            withRoleGuard(UploadEvidenceForm, {
                required: ['Capturer', 'Champion', 'Admin', 'Developer'],
                fallback: (props) =>
                    html`<${MissingPermissionsCard}
                        message="You do not have permission to upload evidence."
                        isAuthenticated=${props?.isAuthenticated}
                    />`,
            })
        ),
        Edit: withAuthGuard(
            withRoleGuard(EditEvidenceForm, {
                required: ['Capturer', 'Champion', 'Admin', 'Developer'],
                fallback: (props) =>
                    html`<${MissingPermissionsCard}
                        message="You do not have permission to edit evidence."
                        isAuthenticated=${props?.isAuthenticated}
                    />`,
            })
        ),
        Review: withAuthGuard(
            withRoleGuard(ReviewEvidenceForm, {
                required: ['Champion', 'Admin', 'Developer'],
                fallback: () => html`<${UploadEvidenceForm} rowData=${rowData} edit=${true} />`,
            })
        ),
        ReadOnly: withAuthGuard(
            withRoleGuard(ViewEvidenceForm, {
                required: ['Capturer', 'Read-Only', 'Champion', 'Admin'],
                fallback: (props) =>
                    html`<${MissingPermissionsCard}
                        message="You do not have permission to view evidence."
                        isAuthenticated=${props?.isAuthenticated}
                    />`,
            })
        ),
    };
};
